import * as React from "react"
import { IconProps } from "./utils"

export function GatsbyIcon({
  height = 20,
  width = 20,
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 14H18V16H22.8C22.1 19 19.9 21.5 17 22.5L5.49999 11C6.69999 7.5 10.1 5 14 5C17 5 19.7 6.5 21.4 8.8L22.9 7.5C20.9 4.8 17.7 3 14 3C8.79999 3 4.39999 6.7 3.29999 11.6L16.5 24.8C21.3 23.6 25 19.2 25 14Z"
        fill="white"
      />
      <path
        d="M3 14.1C3 16.9 4.1 19.6 6.2 21.7C8.3 23.8 11.1 24.9 13.8 24.9L3 14.1Z"
        fill="white"
      />
      <path
        d="M14 0C6.3 0 0 6.3 0 14C0 21.7 6.3 28 14 28C21.7 28 28 21.7 28 14C28 6.3 21.7 0 14 0ZM6.2 21.8C4.1 19.7 3 16.9 3 14.2L13.9 25C11.1 24.9 8.3 23.9 6.2 21.8ZM16.4 24.7L3.3 11.6C4.4 6.7 8.8 3 14 3C17.7 3 20.9 4.8 22.9 7.5L21.4 8.8C19.7 6.5 17 5 14 5C10.1 5 6.8 7.5 5.5 11L17 22.5C19.9 21.5 22.1 19 22.8 16H18V14H25C25 19.2 21.3 23.6 16.4 24.7Z"
        fill="#663399"
      />
    </svg>
  )
}
